/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Base64 } from 'js-base64'
import Switch from 'react-switch'
import { CircularProgress } from '@material-ui/core'
import { FiCheck, FiClock } from 'react-icons/fi'
import usePersistedState from '../../hooks/usePersistedState'
import api from '../../services/api'
import {
  ConfigData,
  UserData,
  UserAddress,
  UserAccount,
  Participant,
  ErroProps,
  UserDetails,
  FinancialIndicationData,
  LegalIndicationData,
} from '../../utils/interfaces'

import Button from '../../components/Button'
import Header from '../../components/Header'
import ModalBox from '../../components/Modal'
import { Content, Confirmation, BtnVoltar, BtnModal } from './styles'
import Container from '../../components/Container'

interface CpfFuncionario {
  cpf: string
}
const Conclusion: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userAddress] = usePersistedState<UserAddress>(
    'userAddress',
    {} as UserAddress,
  )
  const [userAccount] = usePersistedState<UserAccount>(
    'userAccount',
    {} as UserAccount,
  )
  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [financialIndicationData] = usePersistedState<FinancialIndicationData>(
    'financialIndicationData',
    {} as FinancialIndicationData,
  )
  const [legalIndicationData] = usePersistedState<LegalIndicationData>(
    'legalIndicationData',
    {} as LegalIndicationData,
  )
  const [cpfFunc] = usePersistedState<CpfFuncionario>(
    'cpfFuncionario',
    {} as CpfFuncionario,
  )
  const [opcoes] = usePersistedState<string[]>('goalsSelected', [])
  const [selectedReceive] = usePersistedState<'PD' | 'PS' | null>(
    'receiveTypeSelected',
    null,
  )
  const [timeValueYears] = usePersistedState<number>('TimeValueYears', 5)
  const [percentualValuePercent] = usePersistedState<number>(
    'PercentualValuePercent',
    0.3,
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )

  const [aguarde, setAguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)
  const [acceptTerms, setAcceptTerms] = usePersistedState('acceptTerms', false)
  const [acceptTerms2, setAcceptTerms2] = usePersistedState(
    'acceptTerms2',
    false,
  )
  const history = useHistory()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal, setTxtModal] = useState('')
  const [flagRota, setFlagRota] = useState(false)
  const [rota, setRota] = useState('')
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
    if (flagRota) {
      history.push(`${rota}`)
    }
  }, [flagRota, history, rota])

  const handleConfirmaAdesao = useCallback(async () => {
    setAguarde(true)

    const parametros = Base64.encode(`{
        "token": "${configData.token}",
        "versao": "${configData.tipo}",
        "plano": "${configData.plano}",
        "nome": "${userData.name.toLowerCase()}",
        "cpf": "${userData.cpf.replaceAll('.', '').replace('-', '')}",
        "nascimento": "${userData.birthdate}",
        "email": "${userData.email}",
        "telefone": "${userData.phone
          .replace('(', '')
          .replace(') ', '')
          .replace('-', '')}",
        "nomeMae": "${userData.parental.toLowerCase()}",
        "valor":"${userDetails.contribuicaoBasica
          .toFixed(2)
          .toString()
          .replaceAll('.', ',')}",
        "valor_resgate": "${
          selectedReceive === 'PS'
            ? percentualValuePercent.toFixed(2)
            : timeValueYears
        }",
        "forma_resgate": "${selectedReceive}",
        "tempo_contribuicao": "${userDetails.years}",
        "dataPag":"${userDetails.paymentDay}",
        "formaPagamento":"${userAccount.paymentType}",
        "banco":"${userAccount.paymentType === 'B' ? '' : userAccount.banco}",
        "agencia":"${
          userAccount.paymentType === 'B' ? '' : userAccount.agencia
        }",
        "conta":"${userAccount.paymentType === 'B' ? '' : userAccount.conta}",
        "endereco": [{
          "cep":"${userAddress.cep.replace('-', '')}",
          "logradouro":"${userAddress.logradouro.toLowerCase()}",
          "bairro":"${userAddress.bairro.toLowerCase()}",
          "municipio":"${userAddress.municipio.toLowerCase()}",
          "numero":"${userAddress.numero}",
          "complemento":"${userAddress.complemento.toLowerCase()}",
          "uf":"${userAddress.uf}"
        }],
        "politicamenteexposto": "${userDetails.ppe}",
        "usperson": "${userDetails.usperson}",

        "cpfIndicacao": "${
          cpfFunc.cpf === undefined
            ? ''
            : cpfFunc.cpf.replace('.', '').replace('.', '').replace('-', '')
        }",
        "cpfRespFinanc": "${
          financialIndicationData.cpfResponsavelFin === undefined
            ? ''
            : financialIndicationData.cpfResponsavelFin
                .replace('.', '')
                .replace('.', '')
                .replace('-', '')
        }",
        "emailRespFinanc": "${
          financialIndicationData.emailResponsavelFin === undefined
            ? ''
            : financialIndicationData.emailResponsavelFin
        }",
        "nascRespFinanc":"${
          financialIndicationData.birthdateResponsavelFin === undefined
            ? ''
            : financialIndicationData.birthdateResponsavelFin
        }",
        "nomeRespFinanc": "${
          financialIndicationData.nomeResponsavelFin === undefined
            ? ''
            : financialIndicationData.nomeResponsavelFin.toLowerCase()
        }",
        "telRespFinanc": "${
          financialIndicationData.telResponsavelFin === undefined
            ? ''
            : `55${financialIndicationData.telResponsavelFin
                .replace('(', '')
                .replace(') ', '')
                .replace('-', '')}`
        }",
        "respLegal": [{
          "cpfRespLeg": "${
            legalIndicationData.cpfResponsavelLeg === undefined
              ? ''
              : legalIndicationData.cpfResponsavelLeg
                  .replace('.', '')
                  .replace('.', '')
                  .replace('-', '')
          }",
          "emailRespLeg": "${
            legalIndicationData.emailResponsavelLeg === undefined
              ? ''
              : legalIndicationData.emailResponsavelLeg
          }",
          "nascimentoRespLeg":"${
            legalIndicationData.birthdateResponsavelLeg === undefined
              ? ''
              : legalIndicationData.birthdateResponsavelLeg
          }",
          "nomeRespLeg": "${
            legalIndicationData.nomeResponsavelLeg === undefined
              ? ''
              : legalIndicationData.nomeResponsavelLeg.toLowerCase()
          }",
          "telRespLeg": "${
            legalIndicationData.telResponsavelLeg === undefined
              ? ''
              : `55${legalIndicationData.telResponsavelLeg
                  .replace('(', '')
                  .replace(') ', '')
                  .replace('-', '')}`
          }"}
        ],
        "objetivos": [
          ${opcoes.map(opc => `{"id": "${opc}"}`)}
        ],
        "beneficiarios": [${participants.map(
          participant => `
          {"nome": "${participant.data.name.toLowerCase()}",
          "tipo": "${participant.details.tipoBen}",
          "parentesco": "${
            participant.details.grauParentesco === '' ||
            participant.details.grauParentesco === undefined
              ? 99
              : participant.details.grauParentesco
          }",
          "nascimento": "${participant.data.birthdate}",
          "proporcao": "${participant.details.proporcao}",
          "cpf": "${participant.data.cpf
            .replaceAll('.', '')
            .replace('-', '')}"}`,
        )}]
        }`)

    const parametrosFinal = Base64.encode(parametros)

    await api
      .post(`wsAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(() => {
        localStorage.removeItem('@AspADSFamiliaV2:userDetails')
        localStorage.removeItem('@AspADSFamiliaV2:userAddress')
        localStorage.removeItem('@AspADSFamiliaV2:userAccount')
        localStorage.removeItem('@AspADSFamiliaV2:acceptTerms')
        localStorage.removeItem('@AspADSFamiliaV2:acceptTerms2')
        localStorage.removeItem('@AspADSFamiliaV2:erroProps')
        localStorage.removeItem('@AspADSFamiliaV2:TimeValueYears')
        localStorage.removeItem('@AspADSFamiliaV2:codCliente')
        localStorage.removeItem('@AspADSFamiliaV2:participantsGroup')
        localStorage.removeItem('@AspADSFamiliaV2:token')
        localStorage.removeItem('@AspADSFamiliaV2:tipoCont')
        localStorage.removeItem('@AspADSFamiliaV2:cpfFuncionario')
        localStorage.removeItem('@AspADSFamiliaV2:financialIndicationData')
        localStorage.removeItem('@AspADSFamiliaV2:legalIndicationData')
        localStorage.removeItem('@AspADSFamiliaV2:respLegalEqualFin')
        localStorage.removeItem('@AspADSFamiliaV2:tipoPessoa')
        localStorage.removeItem('@AspADSFamiliaV2:respFinanceiro')
        localStorage.removeItem('@AspADSFamiliaV2:acceptTerms')
        localStorage.removeItem('@AspADSFamiliaV2:respLegal')
        localStorage.removeItem('@AspADSFamiliaV2:menorIdade')
        history.push('/end')
      })
      .catch(res => {
        if (res.message === 'Request failed with status code 401') {
          setTxtModal('Tempo de sessão expirado')
          setIsModalOpen(true)
          setFlagRota(true)
          setRota('/')
          // history.push('/')
        } else if (res.message === 'Request failed with status code 406') {
          setTxtModal(
            'Adesão não autorizada. Verifique se você já possui cadastro no plano.',
          )
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
          setAguarde(false)
        } else if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 408') {
          setTxtModal('Tempo de sessão expirado')
          setIsModalOpen(true)
          setFlagRota(true)
          setRota('/register')
          // history.push('/register')
        } else {
          setReSend(false)
          setTimer(20)
          setAguarde(false)
          setTxtModal('Ops, algo deu errado. Tente novamente mais tarde.')
          setIsModalOpen(true)
        }
      })
  }, [
    configData,
    userData,
    userDetails,
    selectedReceive,
    percentualValuePercent,
    timeValueYears,
    userAccount,
    userAddress,
    cpfFunc.cpf,
    financialIndicationData,
    legalIndicationData,
    opcoes,
    participants,
    history,
    setErroProps,
  ])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  const toggleAcceptTerms2 = useCallback(() => {
    setAcceptTerms2(!acceptTerms2)
  }, [acceptTerms2, setAcceptTerms2])

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Confirmation>
            <strong>Da responsabilidade do participante:</strong>
            <div>
              <p>
                Eu <b>{userData.name}</b>, inscrito no CPF <b>{userData.cpf}</b>
                , declaro estar de inteira responsabilidade pelas informações
                realizadas, estando ciente de que a falsidade nas informações
                prestadas configura crime previsto no Código Penal Brasileiro,
                passível de apuração na forma da Lei, bem como poderá ser
                enquadrada como Litigância de Má Fé.
                <Switch
                  onChange={toggleAcceptTerms2}
                  checked={acceptTerms2}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  height={20}
                  width={40}
                  handleDiameter={16}
                  offColor="#FBADB4"
                  offHandleColor="#fff"
                  onHandleColor="#fff"
                  onColor="#31D19E"
                />
              </p>
            </div>
          </Confirmation>
        </Content>

        <Button
          type="button"
          color="blue"
          width="large"
          disabled={!acceptTerms || !acceptTerms2 || !reSend || aguarde}
          onClick={handleConfirmaAdesao}
        >
          {!aguarde ? (
            !reSend ? (
              <>
                <FiClock size={45} />
                <span>
                  Tente novamente em {timer < 10 ? `0${timer}` : timer} segundos
                </span>
              </>
            ) : (
              <>
                <FiCheck size={45} />
                <span>Confirmar adesão</span>
              </>
            )
          ) : (
            <>
              <CircularProgress color="inherit" />
              <span>Aguarde</span>
            </>
          )}
        </Button>

        <BtnVoltar
          type="button"
          onClick={() => history.push('/confirm-ownership')}
        >
          &lt; Anterior
        </BtnVoltar>
        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Conclusion
